import { observable } from '@datagrid/state';

import type { BackendTypes, CSTypes } from '@tf/api';

export type AppStoreType = {
	tenant: string;
	currency: string;
	defaultLocale: string;
	appMeta: BackendTypes.AppMeta;
	defs: CSTypes.GetFrontendIrResponse;
	processingScripts: Record<BackendTypes.SegmentKind, string[]>;
};

export const appStore = observable<AppStoreType>({
	tenant: '',
	currency: '',
	defaultLocale: 'en',
	appMeta: {
		id: '',
		clusterId: '',
		version: '',
		appUrl: '',
	},
	defs: {
		locales: [],
		structs: {},
		selfSegments: {},
		forms: [],
		entities: {},
		options: {},
		paletteItems: [],
	},
	processingScripts: {},
});
